import type { TagJSONObject, TagSummaryJSONObject } from '@ikegps/core-api';
import { ColorHash } from '@ikegps/core-shared';
import { addStyles, DefaultTheme } from '../../components/theme';
import { ColorPaletteOrange } from '../../components/theme.palette';
import { DRAGON_ID, DRAGON_TYPE, DragonDomTypes } from '../../dom';
import { m } from '../../mithril';
import { CurrentState } from '../../state/page.state';

export const CSS = {
	container: 'c-MapTag',
	point: 'c-MapTag__point',
	title: 'c-MapTag__title',
	isHovered: 'c-MapTag--is-hovered',
	isSelected: 'c-MapTag--is-selected',
};

export const CIRCLE_RADIUS = DefaultTheme.spacingFactor * 4;
export const CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';

addStyles({
	[CSS.point]: {
		height: CIRCLE_SIZE_PX,
		width: CIRCLE_SIZE_PX,
		minWidth: CIRCLE_SIZE_PX,
		maxWidth: CIRCLE_SIZE_PX,
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontFamily: DefaultTheme.font.familyCondensed,
		fontWeight: DefaultTheme.font.weight.bold,
		boxShadow: DefaultTheme.shadow.box.dp2,
		textShadow: DefaultTheme.shadow.text,
		position: 'absolute',
		cursor: 'pointer',
		color: DefaultTheme.font.color.white,
		border: `2px solid ${DefaultTheme.font.color.white}`,
	},
	[CSS.title]: {
		fontFamily: DefaultTheme.font.familyCondensed,
		fontWeight: DefaultTheme.font.weight.bold,
		backgroundColor: '#FFF',
		height: DefaultTheme.space(6),
		lineHeight: DefaultTheme.space(6),
		boxShadow: DefaultTheme.shadow.box.dp2,
		fontSize: '125%',
		position: 'absolute',
		width: '120px',
		padding: '4px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		textAlign: 'center',
		whiteSpace: 'no-wrap',
	},
	[`${CSS.point}.${CSS.isHovered}`]: {
		boxShadow: DefaultTheme.shadow.box.dp2w5,
	},
	[CSS.isHovered]: {
		zIndex: 99,
	},
	[CSS.isSelected]: {
		boxShadow: `0 0 0 3px rgba(${ColorPaletteOrange.C700}, 0.24), 0 0 0 3px rgba(${ColorPaletteOrange.C700}, 0.64)`,
	},
	[`${CSS.point}.${CSS.isHovered}.${CSS.isSelected}`]: {
		boxShadow: `0 0 0 5px rgba(${ColorPaletteOrange.C700}, 0.24), 0 0 0 5px rgba(${ColorPaletteOrange.C700}, 0.64)`,
	},
});

export function view(tag: TagJSONObject, summary: TagSummaryJSONObject, point: google.maps.Point) {
	const isHovered = CurrentState.hoverId === tag.objectId;
	const isSelected = CurrentState.Tag.isTagSelected(tag.objectId);

	const domPoint = m(
		'div',
		{
			key: tag.objectId,
			[DRAGON_ID]: tag.objectId,
			[DRAGON_TYPE]: DragonDomTypes.TAG,
			className: `${CSS.point} ${isHovered ? CSS.isHovered : ''} ${isSelected ? CSS.isSelected : ''}`,
			style: {
				backgroundColor: ColorHash.hash(tag.objectId),
				top: point.y - CIRCLE_RADIUS + 'px',
				left: point.x - CIRCLE_RADIUS + 'px',
			},
		},
		summary.revisions.length
	);

	if (isHovered) {
		return m('div', [
			domPoint,
			m(
				'div',
				{
					[DRAGON_ID]: tag.objectId,
					[DRAGON_TYPE]: DragonDomTypes.TAG,
					className: `${CSS.title} ${CSS.isHovered}`,
					style: {
						top: point.y - DefaultTheme.spacingFactor * 14 + 'px',
						left: point.x - 60 + 'px',
					},
				},
				tag.name
			),
		]);
	}

	return domPoint;
}

export const TagMapPoint = { view, Radius: CIRCLE_RADIUS };
